import React from 'react';
import './index.css';

type ButtonProps = {
    children?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    onClick?: () => void;
    secondary?: boolean;
    third?: boolean;
    type?: 'button' | 'submit' | 'reset' | undefined;
};

function Button({
    children,
    className,
    disabled,
    fullWidth,
    onClick,
    secondary,
    third,
    type
}: ButtonProps) {
    return (
        <button
            className={`
                button 
                ${fullWidth && 'button__fullWidth'} 
                ${secondary && 'button__secondary'}
                ${third && 'button__third'}
                ${className} 
            `}
            disabled={disabled}
            type={type}
            onClick={onClick}
        >
            {children}
        </button>
    );
}

export default Button;